/**
 * Represents the type of {@link AppliedQueryFilter} applied to a search.
 *
 * @public
 */
export var AppliedQueryFilterType;
(function (AppliedQueryFilterType) {
    /** Indicates that a field value filter is applied based on the query. */
    AppliedQueryFilterType["FieldValue"] = "FIELD_VALUE";
    /** Indicates that a location filter is applied based on the query. */
    AppliedQueryFilterType["Place"] = "PLACE";
    /** Indicates that a search intent filter is applied based on the query. */
    AppliedQueryFilterType["Intent"] = "INTENT";
})(AppliedQueryFilterType || (AppliedQueryFilterType = {}));
//# sourceMappingURL=AppliedQueryFilterType.js.map